import { render, staticRenderFns } from "./Ambiente.vue?vue&type=template&id=7f303c96&scoped=true&"
import script from "./Ambiente.vue?vue&type=script&lang=js&"
export * from "./Ambiente.vue?vue&type=script&lang=js&"
import style0 from "./Ambiente.vue?vue&type=style&index=0&id=7f303c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f303c96",
  null
  
)

export default component.exports